export class MarketPlaceCategoryDTO {
  PK;
  SK;
  id;
  type;
  status;
  name;
  lookupId;
  questionaireId;
  createdAt;
  updatedAt;
  tenantId;

  constructor(data, tenantId) {
    if (data.id != null) {
      this.PK = data.PK;
      this.SK = data.SK;
    } else {
      this.PK = `${tenantId}#QNAIRE#${data.questionaireId}`;
      this.SK = "CATEGORY#";
    }
    this.id = data.id;
    this.type = 'CATEGORY';
    this.status = data.status;
    this.name = data.name;
    this.lookupId = data.lookupId;
    this.questionaireId = data.questionaireId;
    this.tenantId = tenantId;
  }
}
